<template>
  <div class="hover-animation-container" :class="{ 'out-of-stock': isUnavailable }">
    <v-card
      disabled
      flat
      @click="handleOrderItem"
      class="menuItemCard vertical-card clickable"
      :class="{
        'in-cart': getCartCount > 0,
        'out-of-stock': isUnavailable
      }"
    >
      <div v-if="getImage && !imageError" class="image-wrap" style="padding-top: 12px;">
        <!-- <vuetify-lazy-image
          v-if="!imageError"
          ref="image"
          :src="getImage"
          class="menu-image"
          @error="onError"
        /> -->
        <img :src="getImage" class="menu-image" loading="lazy" @error="onError" />
        <span v-if="getCartCount > 0" class="cart-count">
          {{ getCartCount }}
        </span>
        <!-- <v-btn
          icon
          class="plus-button"
          @click.stop="handlePlusClick"
        >
          <v-icon :class="{ 'outlined-icon': imageError }">add</v-icon>
        </v-btn> -->
      </div>
      <div class="card-content" :class="{ 'no-image': !getImage || imageError }">
        <div class="menu-title">
          <span v-if="menuItem.aiTag" class="ai-tag-pill">{{ menuItem.aiTag }}</span>
          <strong>{{ !!menuItem.shortName ? `(${menuItem.shortName})` : '' }} {{ menuItem.name }}</strong><span v-if="menuItem.caloriesLabel" class="calories-label"> [{{ menuItem.caloriesLabel }}]</span>
        </div>
        <div
          class="menu-desc"
          v-html="appendedDescription(menuItem)"
        ></div>

        <div v-if="hasPromotion && !isUnavailable" class="promo-tag mb-1">
          {{ promotionText }}
        </div>

        <div class="bottom-row">
          <span class="price font-weight-bold">
            <span v-if="isOutOfStock">
              {{ $vuetify.t('$vuetify.menu.soldOut') }} &middot;
            </span>
            <span v-else-if="isOutOfSchedule">
              Not Available
            </span>
            <span v-else>
              <span v-if="minimumRequiredPrice">
                From {{ minimumRequiredPrice | currency }}
              </span>
              <common-price v-else :init-charges="menuItem.charges || []" />
            </span>
          </span>
          <span class="thumb-container" @click.stop="clickThumbsUp">
            <v-icon
              v-if="!userThumbed"
              style="color: black; margin-bottom: 0.5px"
            >
              thumb_up_off_alt
            </v-icon>
            <v-icon
              v-if="userThumbed"
              class="userThumb"
              style="margin-bottom: 0.5px"
            >
              thumb_up
            </v-icon>
            <span v-if="thumbsUpCount > 0" class="thumb-count">
              {{ thumbsUpCount }}
            </span>
          </span>
          <menu-item-tag
            v-for="(tag, tidx) in (menuItem.tags || [])"
            :key="`tag_main_menu_${tidx}`"
            :svg-class="tag"
            :size-px="20"
            :out-of-stock="isUnavailable"
          />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  import get from 'lodash/get';
  import cloneDeep from 'lodash/cloneDeep';

  import { mapActions, mapGetters, mapMutations } from 'vuex'

  import { isNullOrEmpty, buildScheduledTargetDate } from "@/services/util.service"
  import { compareSchedules, getItemScheduleItems } from "@/services/schedule.service"

  import CommonPrice from "@/components/Common/CommonPrice"
  import MenuItemTag from "@/components/MenuItem/menuItemTag"
  import menuItem from '../../stores/modules/menu-item';


  export default {
    props: {
      menuItem: Object,
      listView : Boolean
    },
    components: {
      MenuItemTag,
      CommonPrice
    },

    data() {
      return {
        imageError: false,
        itemDialog: false,
        qty: 0,

        fallbackImg: '/owa/img/other/food_no_image.png',
        path: process.env.VUE_APP_API_IMAGE,
        imgPath: null,
        thumbStateUpdated: false 
      }
    },
    computed: {
      userThumbed() {
        this.thumbStateUpdated; 
        if (this.isLoggedIn) {
          const anonymousLikes = JSON.parse(localStorage.getItem("anonymousLikes") || "{}");
           return this.hasThumbedUpItem && this.hasThumbedUpItem(this.menuItem.code) || !!anonymousLikes[this.menuItem.code];
        } else {
          const anonymousLikes = JSON.parse(localStorage.getItem("anonymousLikes") || "{}");
          return !!anonymousLikes[this.menuItem.code];
        }
      },
      thumbsUpCount() {
        return this.getItemThumbsUp(this.menuItem.code);
      },
      isOutOfStock() {
        return !!get(this.menuItem, 'outOfStock', false)
      },
      isOutOfSchedule() {
        const scheduleDetails = [
          {
            schedule: this.getStoreSchedule,
            advance: this.getHoursLimit
          },
          {
            schedule: getItemScheduleItems(this.menuItem, buildScheduledTargetDate(this.getCheckoutInfo)),
            advance: get(this.menuItem, 'advance', 0)
          }
        ]

        return !compareSchedules(scheduleDetails, buildScheduledTargetDate(this.getCheckoutInfo), this.getStore.timezone || null)
      },

      bestPromotion() {
        const itemCode = this.menuItem.code
        const itemTags = this.menuItem.tags || []
        const charges = this.menuItem.charges || []
        const originalCharge = this.getOriginalChargeFromCharges(charges)
        const flatPrice = get(originalCharge, 'price', 0)
        const relationRequiredPrice = typeof this.getMinimumRequiredRelationPrice === 'function'
          ? this.getMinimumRequiredRelationPrice()
          : 0
        const basePrice = flatPrice !== 0 ? flatPrice : (this.minimumRequiredPrice || relationRequiredPrice || 0)

        return this.getBestPromotionForItem(itemCode, itemTags, basePrice)
      },

      hasPromotion() {
        return this.bestPromotion !== null && this.promotionText !== ''
      },

      promotionText() {
        const promo = this.bestPromotion
        if (!promo) return ''

        const ruleType = promo.ruleType || ''
        const discountValue = promo.discountValue || 0
        const isPercentage = promo.percentageBased

        if (ruleType === 'PromotionBuyOneGetSecondOffRule') {
          if (isPercentage) {
            const percent = Math.round(discountValue * 100)
            if (percent >= 100) {
              return this.$vuetify.t('$vuetify.account.rewards.buy1Get1Free')
            } else if (percent > 0) {
              return this.$vuetify.t('$vuetify.account.rewards.buy1Get1PercentOff', percent)
            }
          } else if (discountValue > 0) {
            const dollars = (discountValue / 100).toFixed(2)
            return this.$vuetify.t('$vuetify.account.rewards.buy1Get1AmountOff', dollars)
          }
          return this.$vuetify.t('$vuetify.account.rewards.buy1Get1Free')
        }

        if (ruleType === 'PromotionOddNumberOffRule') {
          return ''
        }

        if (ruleType === 'PromotionItemDiscountRule') {
          return ''
        }

        return ''
      },

      minimumRequiredPrice() {
        // Original (base) charge only tells us whether the item has its own flat
        // price -- it's not sales-type-aware (its orderTypes check is just a
        // same-priority tie-break, see getOriginalChargeFromCharges), so it's fine
        // for this null-check but must not be used for any price actually shown.
        const originalCharge = this.getOriginalChargeFromCharges(this.menuItem.charges || [])
        const originalPrice = get(originalCharge, 'price', '')

        // If the item has a base price, just use commonprices to show detailed prices
        if (originalPrice !== 0)
          return null

        const _modifiers = get(this.menuItem, 'attributes.Configurable', [])

        const _sumCheapestValues = (mod) => {
          if (mod == null || isNullOrEmpty(mod.values) || mod.minCardinality < 1)
            return 0

          let _remainingQty = mod.minCardinality
          let _sum = 0

          const _sorted = mod.values
            // Resolve each option's price the same way the item modal does
            // (getFinalChargeFromCharges), so a Pickup/Delivery-specific override
            // is picked instead of always falling back to the base/Delivery price.
            .map(_value => {
              return {
                ..._value,
                price: get(this.getFinalChargeFromCharges(_value.charges || []), 'price', 0)
              }
            })
            // Sort from cheapest to most expensive
            .sort((a,b) => a.price - b.price)

            for (let i = 0; i < _sorted.length; i++) {
              const _value = _sorted[i]
              
              // The cheapest option is to select the maximum amount of the cheapest values
              const _upperBound = _value.maxCardinality > 0 ? _value.maxCardinality : _remainingQty

              for (let j = 0; j < _upperBound; j++) {
                _sum += _value.price

                // Stop once we've hit the minimum requirement for the modifier
                _remainingQty--
                if (_remainingQty <= 0)
                  return _sum
              }
            }

            // Somehow _remainingQty didn't hurt 0? Bad data probably, just return sum
            return _sum
        }

        return _modifiers.filter(_mod => _mod.minCardinality >= 1).reduce((sum, _mod) => sum + _sumCheapestValues(_mod), 0)
      },

      isUnavailable() {
        return this.menuItem.disabled || this.isOutOfStock || this.isOutOfSchedule || !this.assignedMenuIsAllowed()
      },

      getCartCount() {
        if (this.$store.getters['groupOrder/isInGroupOrder']) {
          const goItems = this.$store.getters['groupOrder/myCartItems'] || []
          return goItems.reduce((acc, item) => {
            return item.code === this.menuItem.code ? acc + (item.qty || 0) : acc
          }, 0)
        }
        if (this.$store.getters['sharedCart/isActive']) {
          // Only count items still in the draft round — items already sent to
          // the kitchen are a done deal, not part of what's still "in cart".
          const draftItems = this.$store.getters['sharedCart/draftItems'] || []
          return draftItems.reduce((acc, item) => {
            return item.code === this.menuItem.code ? acc + (item.qty || 0) : acc
          }, 0)
        }
        let count = this.getLocalCart.reduce((acc, curr) => {
          const { menuItem = {} } = curr
          const { code, qty } = menuItem

          return code === this.menuItem.code ? acc + qty : acc
        }, 0)

        return count
      },
      getImage: {
        set(val) {
          this.path = val[0]
          this.imgPath = val[1]
        },
        get() {
          // If something (onError) sets an alternative image, prioritize that
          const imgPath = this.imgPath || get(this.menuItem, 'images.MAIN[0].url', '')
          if (imgPath) {
            if (imgPath.startsWith('https://')) {
              return imgPath
            } else {
              return `${this.path}${imgPath}`
            }
          } else {
            return ''
          }
        }
      },

      getListSizePx() {
        return '160px'
      },
      getRowSizePx() {
        return '160px'
      },
      getCardHeight() {
        return `height: ${this.getListSizePx} !important`
      },

      ...mapGetters([
        'getCustomer',
        'isDelivery',
        'isPickUp',
        'isDineIn',
        'getCheckoutInfo',
        'getDeliveryAddress',
        'getStore',
        'getLocalCart',
        'getServerCart',
        'getOrderType',
        'getMenu',
        'getAllMenus',
        'getWorkingMenuItem',
        'getStoreSchedule',
        'getHoursLimit',
        'assignedMenuIsAllowed',
        'getOriginalChargeFromCharges',
        'getFinalChargeFromCharges',
        'getItemThumbsUp',
        'hasThumbedUpItem',
        'isLoggedIn',
        'getBestPromotionForItem',
        'findRealMenuItemByCode'
      ])
    },

    methods: {
      checkDateTime() {
        // Delivery selected but no address yet -- this can happen without ever going
        // through selectOption's own !getDeliveryAddress prompt (e.g. auto-selected as
        // the only off-hour-allowed order type). Catch it here, at the point the guest
        // actually tries to order, rather than popping the dialog unprompted on load.
        if (this.isDelivery && !this.getDeliveryAddress) {
          this.SET_DELIVERY_DIALOG(true)
          return false
        }
        if (
          (!(this.getCheckoutInfo && this.getCheckoutInfo.scheduledDay) ||
            !(this.getCheckoutInfo && this.getCheckoutInfo.scheduledTime))
        ) {
          if (this.isDelivery) {
            this.SET_DELIVERY_DIALOG(true)
            return false
          } else if (this.isPickUp) {
            this.SET_PICKUP_DELIVERY_EDIT_DIALOG(true)
            return false
          } else if (this.isDineIn) {
            //In some corner cases, checkoutInfo scheduledDay/scheduledTime is not set on the first load, 
            //so we need to check if it is a dine in order and allow the user to proceed
            return true
          } else {
            return false; 
          }
        }
        return true
      },
      async clickThumbsUp(event) {
        event.stopPropagation();

        const payload = {
          groupId: this.groupId || this.getStore.groupId,
          storeId: this.storeId || this.getStore.storeId,
          catalogCode: this.menuItem.menuCode,
          itemCode: this.menuItem.code,
          skipLoginPrompt: true
        };

        if (!this.isLoggedIn) {
          const anonymousLikes = JSON.parse(localStorage.getItem("anonymousLikes") || "{}");

          if (anonymousLikes[this.menuItem.code]) {
            payload.itemthumbupid = anonymousLikes[this.menuItem.code];
          }
        }

        try {
          await this.$store.dispatch("thumbsUpItem", payload);
          this.thumbStateUpdated = !this.thumbStateUpdated;
          if (this.isLoggedIn) {
            await this.$store.dispatch("fetchThumbsUpHistory");
          }
        } catch (error) {
          console.error("Error updating thumbs up:", error);
        }
        this.$root.$emit('openLoginDialog', { openedFromThumbsUp: true });
      }, 
      async handlePlusClick(event){ 
        event.stopPropagation();
        const isValid = this.checkDateTime()
        if (!isValid) {
          return
        }
        if (this.isDelivery && (!(this.getCheckoutInfo && this.getCheckoutInfo.scheduledDay) || !(this.getCheckoutInfo && this.getCheckoutInfo.scheduledTime))) {
          await this.setDefaultScheduling();
        }

        //Commenting this based on the ticket DEV-4546

        // const hasRequiredRelations = this.menuItem.relations.filter(relation => {
        //   const { minCardinality } = relation
        //   const selectedItems = relation.selectedItem || []

        //   if (selectedItems && minCardinality > 0)
        //     return selectedItems.reduce((n, { qty }) => n + (qty || 1), 0) < minCardinality
        //   return false
        // }).length

        // const hasRequiredConfigurable = this.menuItem.attributes && this.menuItem.attributes.Configurable && this.menuItem.attributes.Configurable.some(attr => 
        //   attr.minCardinality > 0
        // );

         //Commenting this based on the ticket DEV-4546, the modifier popup should always be shown

        // if (hasRequiredRelations || hasRequiredConfigurable) {
        //   this.handleOrderItem()
        // } else {
        //   const item = { price: this.menuItem.charges[0].price, code: this.menuItem.code, name: this.menuItem.name, itemAttributeList: [], qty: 1, raw: this.menuItem}
        //   if (!this.isUnavailable) {
        //     this.addToCart(item)
        //   }
        // }

        this.handleOrderItem()
      },
      async setDefaultScheduling() {
        const daysAvailable = this.getStoreAvailableOrderDays;
        if (daysAvailable){ 
          const filteredDays = daysAvailable.filter(day => day.id !== 'default');
          
          if (filteredDays && filteredDays.length) {
            await this.SET_CHECKOUT_INFO({
              ...this.getCheckoutInfo,
              scheduledDay: get(filteredDays, '[0].id'),
              scheduledTime: get(filteredDays, '[0].times[0].id')
            });
          }
        }
      },
      appendedDescription() {
        if (this.menuItem.maxCardinality) {
          return `${this.menuItem.description} <span class="bold-red"><span style="font-weight: bold; color: red;">Order Limit: ${this.menuItem.maxCardinality}</span></span>`;
        } else {
          return this.menuItem.description;
        }
      },
      getMinimumRequiredRelationPrice() {
        const relations = get(this.menuItem, 'relations', []) || []
        if (!relations.length || !this.getAllMenus || !this.getAllMenus.length) {
          return 0
        }

        const findMenuItemByCode = (code) => {
          for (const menu of this.getAllMenus) {
            for (const cat of (menu.menuGroups || [])) {
              for (const item of (cat.menuItems || [])) {
                if (item.code === code) return item
              }
            }
          }
          return null
        }

        let total = 0
        for (const relation of relations) {
          const minRequired = Number(get(relation, 'minCardinality', 0)) || 0
          if (minRequired <= 0) continue

          const codes = get(relation, 'menuItemCodes', []) || []
          if (!codes.length) continue

          const prices = codes
            .map((code) => {
              const relatedItem = findMenuItemByCode(code)
              if (!relatedItem) return 0
              const charge = this.getOriginalChargeFromCharges(get(relatedItem, 'charges', []) || [])
              return Number(get(charge, 'price', 0)) || 0
            })
            .filter((p) => p > 0)

          if (!prices.length) continue
          total += Math.min(...prices) * minRequired
        }

        return total
      },
      onError(error) {
        this.imageError = true
      },
      closeAddCart() {
        this.itemDialog = false
      },
      async handleOrderItem() {
        const isValid = this.checkDateTime()
        if (!isValid) {
          return
        }
        if (this.isDelivery && (!(this.getCheckoutInfo && this.getCheckoutInfo.scheduledDay) || !(this.getCheckoutInfo && this.getCheckoutInfo.scheduledTime))) {
          await this.setDefaultScheduling();
        }
        // AI-suggested cards (getAiRecommendationsCategory) are a thin stand-in --
        // {code, name, price} from the AI service, none of the real item's
        // modifiers/attributes/relations. Open the actual menu item by code instead, so
        // the config dialog behaves exactly as if the real card had been clicked.
        const sourceItem = (this.menuItem && this.menuItem.isAiSuggestion)
          ? (this.findRealMenuItemByCode(this.menuItem.code) || this.menuItem)
          : this.menuItem
        const _clone = cloneDeep(sourceItem)

        // Items that implement minCardinality should have min by default
        if ('minCardinality' in _clone)
          _clone.qty = _clone.minCardinality || 1

        this.$store.dispatch('setIsCartItem', false)
        this.$store.commit('SET_IS_OPTION', false)
        this.$store.dispatch('setWorkingMenuItem', _clone)
        this.$store.dispatch('openMenuItemDialog')
      },

      ...mapActions([
        'addToCart',
        'removeFromCart',
        'thumbsUpItem',
        'fetchThumbsUpHistory'
      ]),
      ...mapMutations([
        'SET_CHECKOUT_INFO',
        'SET_PICKUP_DELIVERY_EDIT_DIALOG',
        'SET_DELIVERY_DIALOG',
        'setLoginDialog'
      ])
    },

    mounted() {
      // vuetify lazy loading component doesnt currently listen for error events,
      // so mannually one to the grandchild component
      if (this.$refs.image && this.$refs.image.$children && this.$refs.image.$children.length) {
        this.$refs.image.$children[0].$on('error', this.onError);
      }
    }
  }
</script>

<style>
.calories-label {
  font-size: 0.75em;
  font-weight: 400;
  color: #888;
}
.menuItemCard.vertical-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 16px;
  position: relative;
  min-height: 260px;
  padding-bottom: 8px;
}
.image-wrap {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  min-height: 120px;
}
.menu-image {
  width: 100%;
  max-width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}
.cart-count {
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  width: 40px;
  font-size: 16px;
  height: 40px;
  padding: 9px;
  background: var(--v-primary-base) !important;
  color: white;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1;
  box-sizing: border-box;
}
.plus-button {
  position: absolute !important;
  bottom: 8px;
  right: 8px;
  background-color: white !important;
  color: black !important;
  z-index: 1;
}
.outlined-icon {
  border: 1px solid #DDDDDD !important;
  border-radius: 50%;
  padding: 5px;
}
.card-content {
  flex: 1;
  padding: 12px 16px 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-content.no-image {
  padding: 16px;
  justify-content: flex-start;
}
.menu-title {
  /* font-size: 1.1rem; */
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  color:black;
  line-height: 1.2;
  text-align: left;
}
.ai-tag-pill {
  display: inline-block;
  background-color: #6a1b9a;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 4px;
  vertical-align: middle;
}
.menu-desc {
  /* font-size: 0.95rem; */
  font-size: 18px;
  color: #7A7A7A;
  margin-bottom: auto;
  font-weight: bold;
  text-align: left;
  overflow: hidden;
  /* min-height: 36px;
  max-height: 40px;
  overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.promo-tag {
  display: inline-block;
  background-color: #d32f2f;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-top: 6px;
  align-self: flex-start;
}

.bottom-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
  justify-content: end;
  font-size: 18px;
}
.price {
  /* font-size: 1rem; */
  font-size: 18px;
  font-weight: bold;
  color: #222;
}
.thumb-container {
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  display: inline-flex;
  font-size: 20px;
}
.userThumb {
  color: var(--v-primary-base) !important;
}
.thumb-count {
  margin-left: 2px;
  font-size: 0.9em;
  color: #888;
}
.in-cart {
  border: 2px solid var(--v-primary-base) !important;
}
.out-of-stock .menu-title,
.out-of-stock .menu-desc,
.out-of-stock .price {
  color: #b9b9b9 !important;
}
.out-of-stock .menu-image {
  opacity: 0.5;
  filter: grayscale(100%);
}
.out-of-stock .plus-button {
  background-color: #F8F8F8 !important;
  color: #B9B9B9 !important;
}
.out-of-stock .plus-button .v-icon {
  color: #B9B9B9 !important;
}
.out-of-stock .outlined-icon {
  border-color: #B9B9B9 !important;
}
.menuItemCard.vertical-card {
  width: 265px;
  min-height: 520px;
}

@media (max-width: 600px) {
  .menuItemCard.vertical-card {
    width: 300px !important;
    min-height: 500px !important;
  }
}
</style>